"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Carousel = /*#__PURE__*/function () {
  function Carousel(container, slides, params) {
    _classCallCheck(this, Carousel);

    this.container = container;
    this.carousel = container.querySelector('.js-carousel') || this.container;
    this.slider = container.querySelector('.js-carousel-items');
    this.dots = this.container.querySelector('.js-carousel-dots ul');
    this.legend = document.querySelector('.js-carousel-title');
    this.slides = slides;
    this.length = slides ? slides.length : 0;
    this.profileInfos = this.container.nextElementSibling;
    this.posX = 0;
    this.touching = false;
    this.animating = false;
    var defaultParams = {
      type: 'fade',
      hasTimeout: false,
      transition: 1000,
      cssTransition: 1000,
      responsive: false,
      responsiveBreakpoint: 769,
      responsiveVisibleSlides: 1,
      auto: false,
      delay: 4000,
      infinite: false,
      autoHeigth: false
    };
    this.params = Object.assign(defaultParams, params);
    this.init();
  } ////////////
  // INIT ////
  ////////////


  _createClass(Carousel, [{
    key: "init",
    value: function init() {
      var _this = this;

      // if (this.params.type == 'fade') {
      this.currentIndex = 0; // } else {
      //   this.middleIndex = this.isResponsive() ? 0 : (this.params.visibleSlides - 1)/2;
      //   this.currentIndex = this.middleIndex;
      // }

      if (this.length) {
        this.clear();
        this.setControls(this.length > 1);
        this.slides.map(function (data, index) {
          _this.slider.innerHTML += _this.setSlide(data.path, index);

          if (_this.dots) {
            _this.dots.innerHTML += _this.setDot(index);
          }
        });
      } else {
        this.slides = _toConsumableArray(this.slider.querySelectorAll('.js-carousel-item')); // this.query = this.slider.querySelectorAll('.js-carousel-item');
        // this.element = this.slider.getElementsByClassName('js-carousel-item');

        this.length = this.slides.length; // this.clear();
        // console.log(this.query);
        // console.log(this.element);
        // console.log(this.slides);

        if (this.params.infinite) {
          // Create Clones
          var first = this.slides[this.length - 1].cloneNode(true);
          var last = this.slides[0].cloneNode(true);
          first.dataset.index = -1;
          last.dataset.index = this.length;
          this.slides.forEach(function (slide, index) {
            slide.dataset.index = index;

            _this.slider.appendChild(slide);
          }); // Insert Clones

          this.slider.insertBefore(first, this.slider.firstChild);
          this.slider.appendChild(last);
        } else {
          this.slides.forEach(function (slide, index) {
            slide.dataset.index = index;

            _this.slider.appendChild(slide);
          });
        }

        if (this.dots) {
          var dots = _toConsumableArray(this.dots.querySelectorAll('.js-carousel-dot')); // this.clear(this.dots);


          dots.forEach(function (dot, index) {
            dot.dataset.index = index;

            _this.dots.appendChild(dot);
          });
        }

        this.setControls(this.length > 1);
      }

      this.currentIndex = this.getHashIndex();
      this.setNeighboursClasses();
      this.initSlider();
      this.bindVisibilityChange();
      this.loop();
    }
  }, {
    key: "getHashIndex",
    value: function getHashIndex() {
      var index = 0;

      if (window.location.hash) {
        var hash = window.location.hash.replace('#', '');
        var current = this.slides.filter(function (slide) {
          return slide.dataset.hash == hash;
        });

        if (current.length) {
          index = current[0].dataset.index;
        }
      }

      return index;
    }
  }, {
    key: "bindVisibilityChange",
    value: function bindVisibilityChange() {
      var _this2 = this;

      document.addEventListener("visibilitychange", function () {
        if (document.visibilityState == 'hidden') {
          clearInterval(_this2.interval);
        } else {
          _this2.loop();
        }
      });
    }
  }, {
    key: "initSlider",
    value: function initSlider() {
      var _this3 = this;

      if (this.params.type != 'fade') {
        this.setElementsWidth();
        this.initHammer();

        if (this.params.infinite) {
          this.next(true, false, false);
        } else if (this.currentIndex != 0) {
          this.goTo(this.currentIndex, true, false);
        }

        window.addEventListener('resize', function (event) {
          _this3.setElementsWidth();

          _this3.translate();
        });
        window.addEventListener('hashchange', function (event) {
          var title = window.location.hash.replace('#', '');

          var index = _this3.container.querySelector('[data-hash="' + title + '"]').dataset.index;

          if (!_this3.animating) {
            _this3.goTo(index);
          }
        });
      }
    } ///////////////
    // ACTIONS ////
    ///////////////

  }, {
    key: "prev",
    value: function prev() {
      var translate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var transition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var index = this.currentIndex - 1;
      this.goTo(index, translate, transition);
    }
  }, {
    key: "next",
    value: function next() {
      var translate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var transition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var increment = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var index = increment ? this.currentIndex + 1 : this.currentIndex;
      this.goTo(index, translate, transition);
    }
  }, {
    key: "goTo",
    value: function goTo(index) {
      var translate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var transition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      this.setTransition();

      if (this.params.infinite) {
        if (index >= -1 && index <= this.length) {
          this.currentIndex = index;
        } else if (Math.sign(index) == -1) {
          this.currentIndex = this.length - 1;
        } else if (index > this.length) {
          this.currentIndex = 0;
        }
      } else {
        if (index >= 0) {
          this.currentIndex = index % this.length;
        } else {
          this.currentIndex = this.length - 1;
        }
      }

      this.setNeighboursClasses();

      if (this.dots) {
        var activeDot = this.container.querySelector('.carousel-dot.is-active');
        var current;

        if (index < 0) {
          current = this.container.querySelector('.carousel-dot[data-index="' + parseInt(this.length - 1) + '"]');
        } else if (index == this.length) {
          current = this.container.querySelector('.carousel-dot[data-index="0"]');
        } else {
          current = this.container.querySelector('.carousel-dot[data-index="' + this.currentIndex + '"]');
        }
      }

      if (this.params.type == 'slide' && translate) {
        this.translate(transition);
      }
    } //////////////
    // SETTERS ///
    //////////////

  }, {
    key: "setSlide",
    value: function setSlide(path, index) {
      return index == this.currentIndex ? "<div class=\"carousel-item is-active\" data-index=\"".concat(index, "\"><img src=\"").concat(path, "\"></div>") : "<div class=\"carousel-item\" data-index=\"".concat(index, "\"><img src=\"").concat(path, "\"></div>");
    }
  }, {
    key: "setDot",
    value: function setDot(index) {
      return index == this.currentIndex ? "<li class=\"carousel-dot is-active\" data-index=\"".concat(index, "\">") : "<li class=\"carousel-dot\" data-index=\"".concat(index, "\"></li>");
    }
  }, {
    key: "setActiveClasses",
    value: function setActiveClasses() {
      var _this4 = this;

      var actives = _toConsumableArray(this.container.querySelectorAll('.is-active'));

      var currents = _toConsumableArray(this.container.querySelectorAll('[data-index="' + this.currentIndex + '"]'));

      actives.forEach(function (current) {
        current.classList.remove('is-active');
      });
      currents.forEach(function (current) {
        current.classList.add('is-active');
        current.classList.remove('is-prev');
        current.classList.remove('is-next');
      });

      if (this.current.dataset.title && this.legend) {
        this.legend.innerHTML = this.current.dataset.title;
      }

      if (this.current.dataset.hash) {
        window.location.hash = this.current.dataset.hash;
      }

      if (this.params.autoHeigth && window.innerWidth < this.params.responsiveBreakpoint) {
        setTimeout(function () {
          var current = _this4.slider.querySelector('[data-index="' + _this4.currentIndex + '"]');

          var height = current.offsetHeight;
          console.log(height);
          _this4.slider.style.height = _this4.toPx(height);
        }, 500);
      }
    }
  }, {
    key: "setNeighboursClasses",
    value: function setNeighboursClasses() {
      this.current = this.container.querySelector('.js-carousel-item[data-index="' + this.currentIndex + '"]');
      var prev = this.current.previousElementSibling;
      var next = this.current.nextElementSibling;

      while (prev) {
        prev.classList.add('is-prev');
        prev.classList.remove('is-next');
        prev = prev.previousElementSibling;
      }

      while (next) {
        next.classList.add('is-next');
        next.classList.remove('is-prev');
        next = next.nextElementSibling;
      }

      if (this.params.infinite && this.currentIndex >= this.length - 1) {
        var first = this.container.querySelector('.js-carousel-item[data-index="0"]');
        first.classList.remove('is-prev');
        first.classList.remove('is-next');
      }

      if (this.params.infinite && this.currentIndex < 0) {
        var last = this.container.querySelector('.js-carousel-item[data-index="' + parseInt(this.length - 1) + '"]');
        last.classList.remove('is-prev');
        last.classList.remove('is-next');
      }

      this.setActiveClasses();
    }
  }, {
    key: "setControls",
    value: function setControls(hasLength) {
      var _this5 = this;

      if (hasLength) {
        // this.container.innerHTML += '<nav class="carousel-controls"><button class="button carousel-control prev"><i class="icon icon-chevron"></i></button><button class="button carousel-control next"><i class="icon icon-chevron"></i></button></nav>';
        // REDEFINE SLIDER REFERENCE
        this.slider = this.container.querySelector('.js-carousel-items');
        this.dots = this.container.querySelector('.carousel-dots ul');
        this.container.addEventListener('click', function (event) {
          if (!_this5.animating) {
            if (event.srcElement.classList.contains('js-carousel-control')) {
              event.srcElement.classList.contains('prev') ? _this5.prev() : _this5.next();

              _this5.loop();
            }

            if (event.srcElement.classList.contains('carousel-item')) {
              var index = event.srcElement.dataset.index;
              index != _this5.currentIndex ? _this5.goTo(index) : function () {};

              _this5.loop();
            }

            if (event.srcElement.classList.contains('carousel-dot')) {
              var _index = parseInt(event.srcElement.dataset.index);

              _index != _this5.currentIndex ? _this5.goTo(_index) : function () {};

              _this5.loop();
            }
          }
        });
      }
    }
  }, {
    key: "setElementsWidth",
    value: function setElementsWidth() {
      var _this6 = this;

      if (this.isResponsive()) {
        this.visibleSlides = this.params.responsiveVisibleSlides;
      } else {
        this.visibleSlides = this.params.visibleSlides;
      }

      this.middleIndex = this.isResponsive() ? 0 : (this.visibleSlides - 1) / 2;
      var containerWidth = this.carousel.offsetWidth;
      this.itemWidth = this.carousel.offsetWidth / this.visibleSlides;
      var sliderWidth = this.params.infinite ? this.itemWidth * (this.length + 2) : this.itemWidth * this.length;
      this.setTransition(0);
      this.slider.style.width = this.toPx(sliderWidth);

      var slides = _toConsumableArray(this.slider.querySelectorAll('.carousel-item'));

      slides.forEach(function (el, index) {
        el.style.width = _this6.toPx(_this6.itemWidth);
      });
      this.carousel.classList.add('is-init');
    } //////////////
    // HAMMER ////
    //////////////

  }, {
    key: "initHammer",
    value: function initHammer() {
      var _this7 = this;

      if (window.innerWidth < this.params.responsiveBreakpoint) {
        this.hammer = new Hammer(this.carousel, {
          touchAction: "pan-y"
        });
        this.hammer.on("panleft panright", function (event) {
          if (Math.abs(event.deltaX) > Math.abs(event.deltaY) || _this7.touching) {
            //   console.log('starting')
            clearInterval(_this7.interval);

            _this7.setTransition(0);

            _this7.slider.style.transform = 'translateX(' + _this7.toPx(_this7.posX + event.deltaX) + ')';
            _this7.touching = true;
          }
        });
        this.hammer.on("panend", function (event) {
          // console.log(event)
          var current = -Math.round(event.deltaX / (_this7.itemWidth / 2)) + _this7.currentIndex;

          _this7.setTransition();

          current >= 0 ? _this7.goTo(current) : _this7.goTo(_this7.length - 1);
          _this7.touching = false;

          _this7.loop();
        });
      } // this.hammer.on("swipe", (event) => {
      //   clearInterval(this.interval);
      //   console.log(Math.sign(event.deltaX))
      //   let current = -Math.sign(event.deltaX) + this.currentIndex;
      //   this.slider.style.transitionDuration = this.params.transition;
      //   current >= 0 ? this.goTo(current) : this.goTo(this.length - 1);
      //   this.loop();
      // });

    } ///////////////////////////////
    // TRANSFORM AND TRANSITION ///
    ///////////////////////////////

  }, {
    key: "setTransition",
    value: function setTransition() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.params.transition;
      value = value != 0 ? value / 1000 + 's' : '0s';
      this.slider.style.transitionDuration = value;
    }
  }, {
    key: "translate",
    value: function translate() {
      var _this8 = this;

      var transition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!transition) {
        this.setTransition(0);
      } else {
        this.animating = true;
      }

      this.posX = this.params.infinite ? -this.itemWidth * (this.currentIndex + 1) : -this.itemWidth * this.currentIndex;
      this.slider.style.transform = 'translateX(' + this.toPx(this.posX) + ')';
      this.slider.style['msTransform'] = 'translateX(' + this.toPx(this.posX) + ')';
      this.slider.style['webkitTransform'] = 'translateX(' + this.toPx(this.posX) + ')';
      setTimeout(function () {
        _this8.animating = false;

        if (_this8.currentIndex < 0) {
          _this8.prev(true, false);
        } else if (_this8.currentIndex == _this8.length) {
          _this8.next(true, false);
        }
      }, this.params.cssTransition);
    } //////////////
    // UTILS /////
    //////////////

  }, {
    key: "toPx",
    value: function toPx(value) {
      return value + "px";
    }
  }, {
    key: "isResponsive",
    value: function isResponsive() {
      return this.params.responsive && window.innerWidth < this.params.responsiveBreakpoint;
    }
  }, {
    key: "clear",
    value: function clear() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.slider;
      var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      container.innerHTML = el;
    }
  }, {
    key: "loop",
    value: function loop() {
      var _this9 = this;

      if (this.params.auto) {
        this.interval;
        clearInterval(this.interval);
        this.interval = setInterval(function () {
          _this9.next();
        }, this.params.delay);
      }
    }
  }]);

  return Carousel;
}();

if (document.getElementsByClassName('js-carousel-slider')) {
  var carousels = _toConsumableArray(document.getElementsByClassName('js-carousel-slider'));

  carousels.forEach(function (c) {
    new Carousel(c, null, {
      type: 'slide',
      visibleSlides: 1,
      auto: true,
      transition: 1500,
      cssTransition: 1700,
      delay: 5000,
      infinite: true
    });
  });
}

if (document.getElementsByClassName('js-carousel-container')) {
  var _carousels = _toConsumableArray(document.getElementsByClassName('js-carousel-container'));

  _carousels.forEach(function (c) {
    new Carousel(c, null, {
      type: 'slide',
      visibleSlides: 1,
      transition: 1500,
      cssTransition: 0,
      delay: 5000,
      autoHeigth: true
    });
  });
}